import React from 'react'

type BoxClosedOrderTabIconProps = {
  testId?: string
}

export function BoxClosedOrderTabIcon({ testId }: BoxClosedOrderTabIconProps) {
  return (
    <svg
      width="24"
      height="20"
      viewBox="0 0 24 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      data-testid={testId}
    >
      <path
        d="M0.75 4.17517V14.6662L10.6103 18.5225L20.2151 14.9456V4.21509L10.6262 7.87178L0.75 4.17517ZM0.75 4.17517L10.6262 7.87178"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M10.6094 8.35083V18.5225"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M0.75 4.17515L10.77 0.75L20.2151 4.21507"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M15.4151 6.02742L5.54688 2.33081"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M17.6597 14.1393C17.5 14.1393 17.3404 14.0834 17.1966 13.9796L14.3384 11.8718H14.3144L14.2505 11.8079C13.8673 11.5125 13.8274 11.1133 14.1308 10.6982L14.6338 10.0195C14.8094 9.78 15.017 9.66024 15.2485 9.66024C15.4082 9.66024 15.5679 9.71613 15.7276 9.83589L17.3164 11.0095L21.3723 5.56443C21.4441 5.46862 21.6437 5.21313 21.9871 5.21313C22.1627 5.21313 22.3304 5.28499 22.522 5.42072L23.1927 5.9317C23.5919 6.23509 23.6557 6.64228 23.3603 7.03349L18.1467 14.0355L18.0909 13.9956C17.9551 14.0914 17.8114 14.1393 17.6597 14.1393Z"
        fill="currentColor"
      />
      <path
        d="M21.9967 5.6203C22.0766 5.6203 22.1724 5.66022 22.2841 5.74805L22.9548 6.25903C23.1943 6.44266 23.2023 6.59435 23.0426 6.80194L18.0686 13.4766C17.9568 13.6203 17.8211 13.7321 17.6614 13.7321C17.5895 13.7321 17.5177 13.7081 17.4378 13.6522L17.2941 13.5484L14.5317 11.5125C14.3241 11.3528 14.2842 11.2011 14.4758 10.9457L14.9788 10.267C15.0826 10.1313 15.1784 10.0674 15.2742 10.0674C15.354 10.0674 15.4339 10.0993 15.5217 10.1712L17.4299 11.5764L21.7253 5.8199C21.8211 5.70014 21.9089 5.63627 22.0127 5.63627M21.9967 4.8219C21.7652 4.8219 21.4378 4.90174 21.1344 5.25304L21.0945 5.28497L21.0466 5.35683L17.2462 10.4586L15.9768 9.52449L15.2422 8.98158L15.0746 9.28497C14.843 9.32489 14.5636 9.45264 14.3161 9.78797L13.8131 10.4666C13.5576 10.8019 13.4778 11.1612 13.5656 11.4886L13.4219 11.6962L13.9808 12.1113L14.0526 12.1672L14.1005 12.2071L16.7991 14.2031L16.9428 14.3069C17.1504 14.4666 17.3979 14.5465 17.6454 14.5465C17.7572 14.5465 17.9009 14.5305 18.0446 14.4746L18.2203 14.6023L18.6993 13.9716L23.6734 7.29695C24.1045 6.73008 24.0007 6.07539 23.4339 5.63627L22.7632 5.12529C22.5077 4.92569 22.2522 4.83787 21.9887 4.83787L21.9967 4.8219Z"
        fill="currentColor"
        opacity="0.16"
      />
    </svg>
  )
}
